import { deriveTocEntries } from './tocEntries';
import type { ReportTypeId } from '../config/reportTypes';

/** Build section id → 1-based display number aligned with the TOC when template order is active. */
export function buildSectionDisplayNumbers(input: {
  reportType: ReportTypeId | undefined | null;
  sectionOrder: string[] | undefined;
  effectiveVisibility: Record<string, boolean> | undefined;
  report: Record<string, unknown>;
  reportOverrides?: Record<string, string>;
  templateOverrides?: Record<string, string>;
  /**
   * Part L2 — section ids the COVER carries (e.g. the exec-summary when the
   * masthead/editorial cover renders it as the abstract). They are dropped from
   * the body before numbering so the body section numerals stay in lock-step
   * with the cover TOC, which applies the SAME exclusion + 1..N renumber. Empty
   * / absent ⇒ byte-identical to the prior numbering.
   */
  excludeIds?: readonly string[];
}): Map<string, number> {
  const entries = deriveTocEntries({
    reportType: input.reportType,
    sectionOrder: input.sectionOrder,
    effectiveVisibility: input.effectiveVisibility,
    report: input.report,
    reportOverrides: input.reportOverrides,
    templateOverrides: input.templateOverrides,
  });
  const excluded = input.excludeIds && input.excludeIds.length > 0
    ? new Set(input.excludeIds)
    : null;
  const numbered = excluded ? entries.filter((e) => !excluded.has(e.id)) : entries;
  return new Map(numbered.map((e, i) => [e.id, i + 1]));
}

export function sectionNumberDataAttr(n: number | undefined): { 'data-section-number'?: string } {
  return n != null ? { 'data-section-number': String(n) } : {};
}
